<template>
  <div
    v-if="user.role.name > 0"
    class="min-h-screen border-r border-gray-100 sticky top-0 h-full bg-gray-100 z-20"
  >
  <!-- v-on:mouseleave="menu = false" -->
  <!-- v-on:click="menu = true" -->
    <div
      class="relative top-0 min-h-screen bottom-0 flex items-center align-center flex-col p-4" 
    >
      <!-- <Burger/> -->
      <ul aria-orientation="vertical" class="rounded py-8">
<!--         <div v-if="user.role.name > 0">
        <font-awesome-icon class="text-xl" :icon="['fas', 'user-circle']" />
        </div> -->
        <div v-for="route in navRoutes" :key="route.name">
          <li
            v-if="user.role.name >= route.role"
            class="cursor-pointer text-gray-600 leading-3 tracking-normal mt-6 py-2 hover:text-blue-700 flex items-center focus:text-blue-700 focus:outline-none"
            v-bind:class="{
              'text-blue-500': isCurrentPath(route.path),
            }"
          >
            <a :href="route.path">
              <font-awesome-icon :icon="route.icon" />
            </a>

            <!-- <a v-if="menu" :href="route.path" class="ml-2">{{ route.name }}</a> -->
          </li>
        </div>
        <div v-if="user.role.name > 0">
          
          <li
            class="cursor-pointer text-red-600 leading-3 tracking-normal mt-6 py-2  hover:text-red-700 flex items-center focus:text-red-700 focus:outline-none"
          >
            <button v-on:click="logout">
              <font-awesome-icon :icon="logoutIcon" />
            </button>
          </li>
        </div>
      </ul>
    </div>

    <div
      v-if="menu"
      class="absolute top-0 min-h-screen ml-10 flex items-start flex-col bg-gray-100 transition duration-150 ease-in-out left-0"
      id="mobile-nav"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="opacity-0 pointer-events-none icon icon-tabler icon-tabler-menu-2 cursor-pointer mt-8"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="#718096"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" />
        <line x1="4" y1="6" x2="20" y2="6" />
        <line x1="4" y1="12" x2="20" y2="12" />
        <line x1="4" y1="18" x2="20" y2="18" />
      </svg>

      <ul
        aria-orientation="vertical"
        class="rounded pl-3 pr-32 whitespace-no-wrap pt-8"
      >
      <!--  <div v-if="user.role.name > 0">
        {{user.firstName}}
        </div> -->
        <div v-for="route in navRoutes" :key="route.name">
         
          <li
            v-if="user.role.name >= route.role"
            class="cursor-pointer text-gray-600 leading-3 tracking-normal mt-6 py-2  hover:text-blue-700 flex items-center focus:text-blue-700 focus:outline-none"
            v-bind:class="{ 'text-blue-500': isCurrentPath(route.path) }"
          > 
          <b-tooltip label="OHHHH"
            type="is-light"
            position="is-right">
            <a :href="route.path" class="ml-2">{{ route.name }}</a>
          </b-tooltip>
          </li>
        </div>
        <div v-if="user.role.name > 0">
          <li
            class="cursor-pointer text-red-600 leading-3 tracking-normal mt-6 py-2  hover:text-red-700 flex items-center focus:text-red-700 focus:outline-none"
          >
            <button class="ml-2" v-on:click="logout">Abmelden</button>
          </li>
        </div>
      </ul>
      <br>
    </div>
    <div class="px-2 py-2 text-center">
          <b-taglist attached>
              <b-tag type="is-info">0.0.3</b-tag>
          </b-taglist>
      </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
// import Burger from './Burger.vue'
import {
  faHome,
  faGraduationCap,
  faUser,
  faChalkboard,
  faChalkboardTeacher,
  faSignIn,
  faSignOut,
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faHome,
  faGraduationCap,
  faUser,
  faChalkboard,
  faChalkboardTeacher,
  faSignIn,
  faSignOut
);

export default {
  name: "NavBar",
  components:{
                    // Burger
                },
  data: function() {
    return {
      menu: false,
      routes: this.$router.options.routes,
      user: JSON.parse(localStorage.getItem("user"))
        ? JSON.parse(localStorage.getItem("user"))
        : { role: { name: 0 } },
      logoutIcon: "fas fa-sign-out",
    };
  },
  methods: {
    isCurrentPath(path) {
      if (path === this.$router.history.current.path) return true;
      else return false;
    },
    async logout() {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      this.$router.go("/");
    },
  },
  computed: {
    navRoutes: function() {
      return this.routes.filter((route) => {
        return route.inNav;
      });
    },
  },
};
</script>

<style scoped>
@import url("https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css");
</style>
